import { buildApiUrl } from '../config/api';

export async function fetchAdmissionConfig(schoolID) {
    const res = await fetch(buildApiUrl(`/api/admissions/public/config/${encodeURIComponent(schoolID)}`));
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || 'Could not load school');
    return data;
}

export async function startApplication(payload) {
    const res = await fetch(buildApiUrl('/api/admissions/public/start'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || 'Could not start application');
    return data;
}

export async function verifyPayment(reference) {
    const res = await fetch(buildApiUrl('/api/admissions/public/paystack-verify'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reference }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || 'Payment verification failed');
    return data;
}

export async function lookupStatus(applicationNumber, phone) {
    const q = new URLSearchParams({ applicationNumber, phone });
    const res = await fetch(buildApiUrl(`/api/admissions/public/status?${q}`));
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || 'Status lookup failed');
    return data;
}

const DEFAULT_PUBLIC_SITE_URL = 'https://sisrevolution.com';

/** Public apply URL on website-for-sis — always production unless REACT_APP_PUBLIC_SITE_URL is set. */
export function getPublicSiteBaseUrl() {
    const configured = String(process.env.REACT_APP_PUBLIC_SITE_URL || '').trim();
    if (configured) return configured.replace(/\/$/, '').replace(/#.*$/, '');
    return DEFAULT_PUBLIC_SITE_URL;
}

export function buildPublicApplyUrl(schoolID) {
    const id = String(schoolID || '').trim();
    if (!id) return '';
    return `${getPublicSiteBaseUrl()}/apply/${encodeURIComponent(id)}`;
}

export function buildPublicApplyReturnUrl(schoolID) {
    return buildPublicApplyUrl(schoolID);
}
